<template>
  <Dialog :modal="true" v-model:visible="createprepaymentsvisible" header="Pre Payment" :style="{ width: '40vw' }"
    @after-hide="IsClear">
    <b-container fluid>
      <b-form @submit.prevent="IsSubmit">
        <b-row>
          <b-col>
            <div class="field">
              <TextInput type="text" placeholder="" clearable label="Code" name="Code"
                v-model="prepaymentform_data.Code" :rules="{ required: false, alphanumeric: true }"
                :required-icon="false" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="field">
              <CustomDropDown label="PO Code" name="PO Code" :required-icon="true" @update="loadpoamount"
                :items="listdataval.PoId" v-model="prepaymentform_data.PurchaseOrderID" :rules="{ required: true }" />
            </div>
          </b-col>
          <b-col>
            <div class="field">
              <TextInput placeholder="" clearable label="PO Amount" name="PO Amount"
                v-model="prepaymentform_data.PoAmount" :rules="{ required: true, decimal: true }" :required-icon="true"
                :disabled="true" />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="field">
              <TextInput placeholder="" clearable label="Percentage" name="Percentage"
                v-model="prepaymentform_data.Percentage" :rules="{ required: true, decimal: true }"
                :required-icon="true" @keyup="PercentageOnchange(prepaymentform_data.Percentage)" />
            </div>
          </b-col>
          <b-col>
            <div class="field">
              <TextInput placeholder="" clearable label="PrePayment Amount" name="PrePayment Amount"
                v-model="prepaymentform_data.Amount" :rules="{ required: true, decimal: true }" :required-icon="true"
                @keyup="AmountOnchange(prepaymentform_data.Amount)" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="field">
              <CustomDatePicker label="PrePayment Date" name="PrePayment Date" :required-icon="true" id=""
                :rules="{ required: true }" v-model="prepaymentform_data.PaymentDate"
                :minDate="prepaymentform_data.PODate" />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="field">
              <TextArea placeholder="" label="Remarks" name="Remarks" v-model="prepaymentform_data.Remarks"
                :rules="{ required: false }" :rows="4" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <Footer @cancel="(createprepaymentsvisible = false), IsClear()" type="submit" :label="label"
              :cancelhide="true" />
          </b-col>
        </b-row>
      </b-form>
    </b-container>
  </Dialog>
  <Toast />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>
<script lang="ts">
import { defineComponent, ref, watch, computed, watchEffect, onMounted } from "vue";
import TextInput from "../../../../../../components/FormComponents/TextInput.vue";
import TextArea from "../../../../../../components/FormComponents/TextArea.vue";
import CustomDatePicker from "../../../../../../components/FormComponents/DatePicker.vue";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import common from "../../../../.../../../../modules/Inventory/Service/CommonService";
import SupplierPaymentService from "../../../../../../modules/Inventory/Service/SupplierPrePayment";
import WithoutStockAffectService from "../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useForm } from "vee-validate";
import moment from "moment";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import { value } from 'dom7';
import { useToast } from "primevue/usetoast";

export default defineComponent({
  props: {
    showprepayDialog: {
      type: Boolean,
      default: false,
    },
    datas: {
      type: Array,
      default: [],
    },
    selectedItem: {
      type: Object,
      Default: () => { },
    },
  },
  components: {
    TextInput,
    TextArea,
    CustomDatePicker,
    CustomDropDown,
    Footer,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const createprepaymentsvisible = ref(props.showprepayDialog);
    let UserData = ref();
    UserData.value = localStorage.getItem("UsersData");
    UserData.value = JSON.parse(UserData.value);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    const router = useRouter();
    const route = useRoute();
    const toast = useToast();

    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const supplierdatas: any = ref([]);
    const model: any = ref(props.selectedItem);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let branchid = Number(UserData.value.BranchId);
    let hospitalid = Number(UserData.value.HospitalId);
    if (model.value != null) {
      IsEdit();
    } else {
      GetCode();
      label.value = "Save";
    }
    let RolesData = ref();
    RolesData.value = localStorage.getItem("RolesData");
    RolesData.value = JSON.parse(RolesData.value);
    const prepaymentform_data = ref({
      PrepaymentID: 0,
      Code: "",
      SupplierID: 0,
      PurchaseOrderID: ref(),
      PoAmount: ref(),
      Percentage: ref(),
      Amount: ref(),
      PaymentDate: "",
      Remarks: ref(),
      EntityId: 0,
      HospitalId: 0,
      BranchId: 0,
      CreatedAt: "",
      ModifiedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      Status: 0,
      AppliedInvoiceID: 0,
      IsPORelated: false,
      EntityOperationId: 0,
      DeptRoleId: 0,
      PODate: ref()

    });
    const copyprepaymentform_data = JSON.parse(JSON.stringify(prepaymentform_data.value));
    const listdataval = ref({
      PoId: ref([]),
    });
    watch(
      () => props.datas,
      (newVal: any) => {
        supplierdatas.value = newVal;
        prepaymentform_data.value.SupplierID = supplierdatas.value.SupplierId;
        LoadPoList();
      }
    );
    onMounted(() => {
      supplierdatas.value = props.datas;
      prepaymentform_data.value.SupplierID = supplierdatas.value.SupplierId;
      LoadPoList();
    });

    //Get Auto generate Code
    async function GetCode() {
      try {
        let data = {
          // EntityId: Entitydata.value.EntityId,
          EntityId: 3090,
          HospitalId: hospitalid,
          BranchId: branchid,
          StoreId: 0,
        };
        let result: any = await common.getCodeTemplate(data);
        console.log(result);
        prepaymentform_data.value.Code = result;
      } catch (error) { }
    }
    async function IsEdit() {
      createprepaymentsvisible.value = true;
      try {

        label.value = "Update";
        let Id = model.value.PrepaymentID;
        let response = await SupplierPaymentService.GetData(Id, hospitalid, branchid);
        let datas = response["result"];
        Object.keys(prepaymentform_data.value).forEach((key) => {
          if (datas[key]) prepaymentform_data.value[key] = datas[key];
        });
        await LoadPoList()
        // prepaymentform_data.value.PaymentDate = moment(
        //   prepaymentform_data.value.PaymentDate
        // ).format("YYYY-MM-DD");
      } catch (error) {
        console.log(error);
      }
    }
    const IsSubmit = handleSubmit(async (values) => {
      let result: any;
      let msg = "";
      prepaymentform_data.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      prepaymentform_data.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      prepaymentform_data.value.PaymentDate = moment(
        prepaymentform_data.value.PaymentDate
      ).format("YYYY-MM-DD");
      prepaymentform_data.value.BranchId = branchid;
      prepaymentform_data.value.HospitalId = hospitalid;
      prepaymentform_data.value.ModifiedBy = Number(UserData.value.UserId);
      prepaymentform_data.value.CreatedBy = Number(UserData.value.UserId);
      prepaymentform_data.value.EntityId = 3090;
      prepaymentform_data.value.EntityOperationId = 3090001;
      prepaymentform_data.value.Amount = Number(prepaymentform_data.value.Amount);
      prepaymentform_data.value.DeptRoleId = Number(RolesData.value.DeptRoleMapId);
      if (prepaymentform_data.value.PrepaymentID != 0) {
        result = await SupplierPaymentService.UpdateData(prepaymentform_data.value);
        console.log(result);
        msg = result["ErrorInfo"].ErrorCode;
        debugger;
        debugger;
        if (result["result"] == "Already" && msg == null) {
          createprepaymentsvisible.value = false;
          alreadyexistpop.value = true;
        } else if (msg == null) {
          createprepaymentsvisible.value = false;
          updatepop.value = true;
        }
      } else {
        result = await SupplierPaymentService.CreateData(prepaymentform_data.value);
        console.log(result);
        msg = result["ErrorInfo"].ErrorCode;
        if (result["result"] == "Already" && msg == null) {
          createprepaymentsvisible.value = false;
          alreadyexistpop.value = true;
        } else if (msg == null) {
          createprepaymentsvisible.value = false;
          successpop.value = true;
        }
      }
    });
    async function LoadPoList() {
      try {
        if (prepaymentform_data.value.SupplierID != 0) {
          let result = await WithoutStockAffectService.GetPoListBySupplierId(
            prepaymentform_data.value.SupplierID,
            route.query.StoreBranchMapId,
            "4,6"
          );
          listdataval.value.PoId = result["result"]
            .filter((item) => item.DocNo != null)
            .map((item) => {
              item.name = item.DocNo;
              item.value = item.Id;
              return item;
            });
        }
      } catch (error) { }
    }
    function loadpoamount() {
      debugger
      let poid = prepaymentform_data.value.PurchaseOrderID;
      if (listdataval.value.PoId) {
        const filteredItem = listdataval.value.PoId.find(item => item['Id'] == poid);
        if (filteredItem) {
          prepaymentform_data.value.PoAmount = filteredItem['Amount'];
          prepaymentform_data.value.PODate = new Date(moment(filteredItem['DocDate'], "DD-MM-YYYY").toISOString());
        }
      }
    }


    //Clear Input Fields
    function IsClear() {
      Object.assign(prepaymentform_data.value, copyprepaymentform_data);
      prepaymentform_data.value.PurchaseOrderID = ref();
      emit("update:selectedItem", undefined);
      emit("closepopup", createprepaymentsvisible.value);
    }
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      IsClear();
    }
    function alreadyclosetrigger() {
      alreadyexistpop.value = false;
    }

    // watch(
    //   () => prepaymentform_data.value.Percentage,
    //   (newPercentage) => {
    //     debugger
    //     alert('Percentage')
    //     if (prepaymentform_data.value.PoAmount > 0 && newPercentage !== null) {
    //       prepaymentform_data.value.Amount =
    //         parseFloat(((prepaymentform_data.value.PoAmount * newPercentage) / 100).toFixed(2));
    //     }
    //   }
    // );
    function PercentageOnchange(newPercentage) {
      if (newPercentage <= 100) {
        if (prepaymentform_data.value.PoAmount > 0 && newPercentage !== null) {
          prepaymentform_data.value.Amount =
            parseFloat(((prepaymentform_data.value.PoAmount * newPercentage) / 100).toFixed(2));
        }
      }
      else {
        toast.add({
          severity: "warn",
          summary: "Percentage  Should be below 100",
          detail: "",
          life: 3000,
        });
        prepaymentform_data.value.Percentage = 100
      }

    }
    function AmountOnchange(newAmount) {
      if (newAmount <= prepaymentform_data.value.PoAmount) {
        if (prepaymentform_data.value.PoAmount > 0 && newAmount !== null) {
          prepaymentform_data.value.Percentage =
            parseFloat(((newAmount / prepaymentform_data.value.PoAmount) * 100).toFixed(2));
        }
      }
      else {
        toast.add({
          severity: "warn",
          summary: "PrePayment Amount Should Be less Than PoAmount",
          detail: "",
          life: 3000,
        });
        prepaymentform_data.value.Amount = prepaymentform_data.value.PoAmount
      }
    }

    // watch(
    //   () => prepaymentform_data.value.Amount,
    //   (newAmount) => {
    //     debugger
    //     if (prepaymentform_data.value.PoAmount > 0 && newAmount !== null) {
    //       prepaymentform_data.value.Percentage =
    //         parseFloat(((newAmount / prepaymentform_data.value.PoAmount) * 100).toFixed(2));
    //     }
    //   }
    // );

    return {
      createprepaymentsvisible,
      loading,
      IsSubmit,
      IsClear,
      closetrigger,
      alreadyclosetrigger,
      supplierdatas,
      prepaymentform_data,
      successpop,
      updatepop,
      alreadyexistpop,
      listdataval,
      model,
      IsEdit,
      label,
      branchid,
      hospitalid,
      loadpoamount,
      PercentageOnchange,
      AmountOnchange
    };
  },
});
</script>

<style lang="scss">
.patientdetailspopupcard {
  background: #f5f5f5;
  padding: 10px 15px;
  border-radius: 10px;
  color: #999999;

  p {
    margin-bottom: 7px;
  }

  span {
    color: #444444;
  }

  >div {
    display: flex;
    padding: 15px 0px;

    div:nth-child(2) {
      border-left: 1px solid #e1e1e1;
      border-right: 1px solid #e1e1e1;
      padding-inline: 15px;
      margin-inline: 15px;
    }
  }
}
</style>
